import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "d-flex flex-column h-100" }
const _hoisted_2 = { style: {"flex-grow":"2"} }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<header><div class=\"container\"><div class=\"navbar navbar-expand-lg navbar-light\"><div class=\"header-logo d-flex align-items-center\"><div class=\"logo pe-5 me-5 border-end border-2 border-secondary h-70px\"><img alt=\"PERU FEDUP\" src=\"/media/logos/fedup_escudo.png\" class=\"h-70px\"></div><div class=\"title\"><h1 class=\"my-0 text-fdp-blue\">Mesa de Partes Virtual</h1><p class=\"my-0 text-fdp-blue\">Servicios en Línea</p></div></div></div></div></header><div class=\"h-35px bg-fdp-blue\"></div>", 2)
const _hoisted_5 = { class: "container" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-md-6 offset-md-3" }
const _hoisted_8 = {
  key: 0,
  class: "activate-account p-10"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("h5", { class: "text-center text-uppercase text-danger mb-6" }, "Activación de cuenta de usuario", -1)
const _hoisted_10 = {
  key: 0,
  alt: "PERU FEDUP",
  src: "/media/illustrations/16.png",
  class: "m-auto h-300px d-block mb-6"
}
const _hoisted_11 = {
  key: 1,
  alt: "PERU FEDUP",
  src: "/media/illustrations/not_found.png",
  class: "m-auto h-200px d-block mb-6"
}
const _hoisted_12 = {
  key: 0,
  class: "fa fa-check text-success mx-2",
  "aria-hidden": "true"
}
const _hoisted_13 = {
  key: 1,
  class: "fa fa-times text-danger mx-2",
  "aria-hidden": "true"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("footer", { class: "bg-fdp-blue py-2" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "container" }, [
    /*#__PURE__*/_createElementVNode("p", { class: "text-center text-white my-0" }, "Todos los derechos reservados / PERU FEDUP / ©2023")
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("main", null, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              (_ctx.resp.status!='')
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _hoisted_9,
                    (_ctx.resp.status == 'success')
                      ? (_openBlock(), _createElementBlock("img", _hoisted_10))
                      : (_openBlock(), _createElementBlock("img", _hoisted_11)),
                    _createElementVNode("div", {
                      class: _normalizeClass('alert alert-' + _ctx.resp.status + ' d-flex align-items-center'),
                      role: "alert"
                    }, [
                      (_ctx.resp.status == 'success')
                        ? (_openBlock(), _createElementBlock("i", _hoisted_12))
                        : (_openBlock(), _createElementBlock("i", _hoisted_13)),
                      _createTextVNode(" " + _toDisplayString(_ctx.resp.message), 1)
                    ], 2),
                    _createElementVNode("button", {
                      type: "button",
                      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goMpv && _ctx.goMpv(...args))),
                      class: "btn btn-success m-auto d-block"
                    }, "Ir a mesa de partes")
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ]),
    _hoisted_14
  ])), [
    [
      _directive_loading,
      _ctx.fullscreenLoading,
      void 0,
      {
        fullscreen: true,
        lock: true
      }
    ]
  ])
}